import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'reduxjs-toolkit-persist';
import { cacheMiddleware } from './middlewares/cache';
import { opHistoryMiddleware } from './middlewares/op-history';
import { patchRxjsMiddleware } from './middlewares/patch-rxjs';
import { persistenceMiddleware } from './middlewares/persistence';
import { persistReducers } from './persist';
import type * as reducers from './reducers';

type RootState = {
  [K in keyof typeof reducers]: ReturnType<typeof reducers[K]>;
};

export const store = configureStore<RootState>({
  reducer: persistReducers,
  devTools: __HOST_LOCAL__,
  middleware: (getDefaults): any => {
    return getDefaults({
      serializableCheck: false,
    }).concat(persistenceMiddleware, opHistoryMiddleware, cacheMiddleware, patchRxjsMiddleware);
  },
});

export const persister = persistStore(store);

export const { getState, dispatch, subscribe } = store;

export const cache = new Proxy(getState(), {
  get(_, p) {
    return Reflect.get(getState(), p);
  },
});
